<script>
export default {
    name: 'TrainingsProgress',
    props: {
        trainings: {
            type: Array,
            required: true,
        }
    },
    computed: {
        total() {
            return this.trainings.length;
        },
        completed() {
            return this.trainings.filter(t => t.is_opened).length;
        },
        percentage() {
            if (this.total === 0) return 0;
            return Math.round((this.completed / this.total) * 100);
        }
    }
}
</script>
<template>
    <div class="training-progress mb-4">
        <div class="is-flex is-justify-content-space-between mb-1">
            <span class="has-text-weight-semibold">Postęp</span>
            <span>{{ completed }} / {{ total }} lekcji ({{ percentage }}%)</span>
        </div>
        <progress class="progress is-success is-medium" :value="completed" :max="total">
            {{ percentage }}%
        </progress>
    </div>
</template>
